const WebAutomation = {
  path: "",
  name: "",
  redirect: "/web-automation",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/web-automation",
      redirect: "/web-automation",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Web Automation",
      meta: {
        requiresAuth: true,
        activeUrl: "/web-automation",
        parent: "/web-automation",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/webAutomation/index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/web-automation",
            parent: "/web-automation",
            isChildren: true,
            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Web Automation Detail",
          component: () =>
            import("@/views/pages/webAutomation/detail/Detail.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/web-automation",
            parent: "/web-automation",
            lv: 2,
          },
        },
      ],
    },
  ],
};

export default WebAutomation;
